import Marionette from 'lib/marionette'
import template from 'templates/admin/misc'

import Socket from 'lib/socket'
import Toast from 'toastr'
import { filesize } from 'filesize'

import Debug from 'debug'
const debug = Debug('pandore:views:admin:actions')

const AdminMiscView = Marionette.View.extend({
	template: template,
	className: 'misc container',

	ui: {
		usedDiskSpaceValue: '#usedDiskSpaceValue',
		usedDiskSpaceIndicator: '#usedDiskSpaceIndicator',
	},

	initialize() {
		debug('Initializing AdminMiscView:',this.options)
	},

	onRender() {
		this.monitorDiskSpace()
	},

	monitorDiskSpace() {
		this.diskSpaceInterval = this.setInterval(this.refreshDiskSpace.bind(this), 1000)
		this.refreshDiskSpace()
	},

	async refreshDiskSpace() {
		try {
			const result = await Socket.emit('diskspace:info')
			// debug('>>>>>',result)
			//
			const percentUsed = (result.used*100)/result.total
			const roundedValue = Math.round(percentUsed*10)/10
			this.ui.usedDiskSpaceValue.text(`${roundedValue}% (${filesize(result.used,{base:2})} / ${filesize(result.total,{base:2})})`)
			this.ui.usedDiskSpaceIndicator.attr({
				max: result.total,
				value: result.used,
			})

		} catch(err) {
			console.error(err)
			Toast.error(`Error fetching disk space data: ${err.message}`)
			clearInterval(this.diskSpaceInterval)
		}
	}
})

export default AdminMiscView
